module.exports = __webpack_public_path__ + "static/media/adep.9de8d84c.png";